<template>
  <div class="flex flex-col rounded-full shadow-sm border py-4 px-1 gap-0.5 bg-white">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';

const closeRef = ref<() => void>();
provide('sm-drawing-menu-close', closeRef);

defineExpose({
  close: () => {
    closeRef.value = undefined;
  },
});
</script>
